import { useEffect } from 'react';
import { useSettingsStore } from '@/stores/settingsStore';

// Keeps <html class="dark"> in sync with the persisted theme so Tailwind's
// `dark:` variants and the CSS-variable palette in tailwind.css react to it.
export function useSyncThemeMode(): void {
  const themeMode = useSettingsStore(state => state.themeMode);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', themeMode === 'dark');
  }, [themeMode]);
}
